import React from "react";
import { Row, Col, Carousel, Typography, Grid, Image } from "antd";

import m1 from "../Assets4/00.jpg";

import m7 from "../Assets4/6.jpg";
import m8 from "../Assets4/7.jpg";
import m9 from "../Assets4/8.jpg";
import m10 from "../Assets4/9.jpg";
import m12 from "../Assets4/12.jpg";
import m13 from "../Assets4/11.jpg";
import m14 from "../Assets4/13.jpg";
import m15 from "../Assets4/14.jpg";
import m16 from "../Assets4/15.jpg";
import m17 from "../Assets4/16.jpg";
import m18 from "../Assets4/17.jpg";
import m19 from "../Assets4/18.jpg";
import m20 from "../Assets4/19.jpg";
import m21 from "../Assets4/20.jpg";
import m22 from "../Assets4/21.jpg";
import m23 from "../Assets4/22.jpg";
import m24 from "../Assets4/23.jpg";
import m25 from "../Assets4/24.jpg";
import m26 from "../Assets4/25.jpg";

const { Title, Paragraph } = Typography;
const { useBreakpoint } = Grid;

const images = [
  m1, m7, m8,
  m9, m10, m12, m13, m14, m15, m16,m17,m18,m19,m20,m21,m22,m23,m24,m25,m26
];

const ConferenceIntro = () => {
  const screens = useBreakpoint();

  const titleFontSize = screens.xl
    ? "48px"
    : screens.lg
    ? "48px"
    : screens.md
    ? "46px"
    : "36px";

  const paragraphFontSize = screens.xl
    ? "17px"
    : screens.lg
    ? "17px"
    : screens.md
    ? "15px"
    : "15px";

  const paragraphLineHeight = screens.md ? "1.8em" : "1.6em";
  const paragraphPadding = screens.md ? "0 20px" : "0 5px";

  return (
    <div
      style={{
        backgroundColor: "#0D102D",
        padding: "10px",
        borderRadius: "0 10px 10px 0",
        overflow: "hidden",
        maxWidth: "100%",
      }}
    >
      <Row
        align="top"
        gutter={[16, 16]}
        style={{
          backgroundColor: "#0D102D",
          padding: "40px",
          borderRadius: "0 10px 10px 0",
        }}
      >
        <Col xs={24} md={12} lg={14}>
          <Title
            style={{
              fontSize: titleFontSize,
              padding: paragraphPadding,
              color: "white",
              fontFamily: "Inter, sans-serif",
              fontWeight: 700,
              letterSpacing: "1px",
              textAlign: "left",
            }}
          >
            Introduction
          </Title>

          <Paragraph style={{ color: "white", fontFamily: "Inter, sans-serif", lineHeight: paragraphLineHeight, letterSpacing: "0.5px", fontSize: paragraphFontSize, textAlign: "justify", padding: paragraphPadding, lineHeight: "2rem", }} > The International Conference on Applications of Space Science and Technology (ICAST) marks a transformative milestone in Pakistan&#39;s journey through space science and technology. As the largest space event in the country, ICAST unites the legacies of IST’s International Conference on Aerospace Science and Engineering (ICASE) and SUPARCO’s International Conference on Space (ICS) into a biennial global forum of unparalleled excellence. ICAST bringing together visionaries, global thought leaders, pioneering researchers, and industry trailblazers, aspires to redefine the future of space science by fostering collaboration, presenting transformative research, and exploring interdisciplinary space applications with the potential to reshape our collective future. </Paragraph>
        </Col>

        <Col xs={24} md={12} lg={10}>
          <Carousel arrows autoplay>
            {images.map((img, index) => (
              <div key={index}>
                <Image
                  preview={false}
                  src={img}
                  alt={`Conference Image ${index + 1}`}
                  style={{
                    width: "100%",
                    height: "auto",
                    borderRadius: "10px",
                  }}
                />
              </div>
            ))}
          </Carousel>
        </Col>
      </Row>
    </div>
  );
};

export default ConferenceIntro;
